import { ImgHTMLAttributes } from 'react';
import majesticFavicon from './assets/majestic.png';

export const MajesticIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img src={majesticFavicon} width={12} height={12} {...props} alt="" aria-hidden="true" />
);
